import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";

const AppleBtn = ({ className, style }: CustomComponentProps) => {
    return (
        <div className={`field ${className}`} style={style}>
            <div className="control">
                <a
                    href="#"
                    className="button raised is-rounded is-fullwidth d-flex gap-5"
                >
                    <SVG svg="apple" size={24} />
                    Sign up with Apple
                </a>
            </div>
        </div>
    );
};

export default AppleBtn;
